import { i18n } from "@lingui/core";
import React from 'react';
import './input.scss';
import { getAllLocaleUtils } from '../../../../hooks/i18n-hook';

// TODO: how to translate placeholder?
var Input = function Input(_ref) {
  var element = _ref.element,
      label = _ref.label,
      type = _ref.type,
      name = _ref.name,
      placeholder = _ref.placeholder,
      options = _ref.options;
  console.log({
    options: options
  });

  var _getAllLocaleUtils = getAllLocaleUtils(),
      i18n = _getAllLocaleUtils.i18n;

  var inputElement;

  switch (element) {
    case 'input':
      inputElement = /*#__PURE__*/React.createElement("input", {
        type: type,
        name: name,
        placeholder: i18n._(placeholder)
      });
      break;

    case 'textarea':
      inputElement = /*#__PURE__*/React.createElement("textarea", {
        name: name,
        placeholder: i18n._(placeholder)
      });
      break;

    case 'select':
      inputElement = /*#__PURE__*/React.createElement("select", {
        name: name
      }, /*#__PURE__*/React.createElement("option", {
        value: ""
      }, i18n._(
      /*i18n*/
      i18n._("Please select one"))), options && options.map(function (opt) {
        return /*#__PURE__*/React.createElement("option", {
          key: opt.value,
          value: opt.value
        }, opt.name);
      }));
      break;

    default:
      inputElement = /*#__PURE__*/React.createElement("input", {
        type: type,
        name: name,
        placeholder: i18n._(placeholder)
      });
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "form-control"
  }, /*#__PURE__*/React.createElement("label", null, i18n._(label), ": ", inputElement));
};

export default Input;